import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SearchableDropdown } from 'elements/Inputs/FormInput/SearchableDropdown';
import { setSelectedTRF } from 'journeys/portal/Forms/Forms.actions';
import { SelectDropdown, DropDownStyle, SelectLabel } from '../../common/footer/Footer.styled';

const TrfDropdownSelection = (props) => {
    const { settingSelectedTRF, trfMasterList } = props;
    const activeTRFId = trfMasterList?.filter(x => x.Status === 'Active' && x.TrfShortDesc !== 'Not In MRAT');
    const [selectTrfId, setSelectTrfId] = useState('');
    const formHandler = (obj) => {
        const SelectTrfid = trfMasterList?.find(x => x.TrfShortDescReplaceWhenActive === obj?.trfMasterList)?.TrfId;
        setSelectTrfId(SelectTrfid);
        settingSelectedTRF(SelectTrfid);
    };
    return (
        <div style={{ position: 'relative' }}>
            <div className="container">
                <div style={{ display: 'flex' }}>
                    <SelectLabel style={{ marginRight: '0', marginLeft: '10px' }}>Select TRF</SelectLabel>
                    <DropDownStyle style={{ marginTop: '4px' }}>
                        <SelectDropdown>
                            <SearchableDropdown
                                width="224px"
                                height="2rem"
                                name="trfMasterList"
                                value={activeTRFId?.find(x => x.TrfId === selectTrfId)?.TrfShortDescReplaceWhenActive || ''}
                                handleChange={formHandler}
                                placeholder="Select TRF"
                                options={activeTRFId?.map(x => ({ name: x.TrfShortDescReplaceWhenActive, value: x.TrfShortDescReplaceWhenActive }))}
                                alignItems="flex-start"
                                flexDirection="column"
                                selectMarginLeft="15px"
                            />
                        </SelectDropdown>
                    </DropDownStyle>
                </div>
            </div>
        </div>
    );
};

TrfDropdownSelection.propTypes = {
    settingSelectedTRF: PropTypes.func,
    trfMasterList: PropTypes.array,
};

const mapStateToProps = ({ Home, Forms }) => ({
    userRole: Home.userRole,
    trfMasterList: Home.trfMasterList,
    formData: Forms.formData
});

const mapDispatchToProps = dispatch => ({
    dispatch,
    settingSelectedTRF: (selectedTrfId) => dispatch(setSelectedTRF(selectedTrfId)),
});
export default connect(mapStateToProps, mapDispatchToProps)(TrfDropdownSelection);
